import { render, staticRenderFns } from "./addGroup.vue?vue&type=template&id=48198678"
import script from "./addGroup.vue?vue&type=script&lang=js"
export * from "./addGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48198678')) {
      api.createRecord('48198678', component.options)
    } else {
      api.reload('48198678', component.options)
    }
    module.hot.accept("./addGroup.vue?vue&type=template&id=48198678", function () {
      api.rerender('48198678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/goodsGrouped/addGroup.vue"
export default component.exports